import React, { createContext, useContext, useMemo } from 'react';

const BulkPublishModeContext = createContext<boolean>(false);

type Props = {
  enabled: boolean;
  children: React.ReactNode;
};

export const BulkPublishModeProvider = ({ enabled, children }: Props) => {
  const value = useMemo(() => enabled, [enabled]);
  return (
    <BulkPublishModeContext.Provider value={value}>
      {children}
    </BulkPublishModeContext.Provider>
  );
};

export const useBulkPublishMode = (): boolean =>
  useContext(BulkPublishModeContext);
